import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectItem,
  SelectContent,
} from "@/components/ui/select";
import { toast } from "sonner";
import { useWebsites } from "@/context/WebsitesContext";

const CmsSelectionCard: React.FC = () => {
  const { currentWebsite, updateWebsite } = useWebsites();

  if (!currentWebsite) return null;

  return (
    <Card id="cms-selection">
      <CardHeader>
        <CardTitle>Content management system</CardTitle>
        <CardDescription>
          Select the CMS you use for this website. This controls which integrations are
          available.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-4">
          <Label htmlFor="cms-select">CMS</Label>
          <Select
            value={currentWebsite.cms || "wordpress"}
            onValueChange={async (value) => {
              // Log and update CMS
              console.log("CMS changed to", value);
              try {
                // Only pass valid properties to updateWebsite
                await updateWebsite(currentWebsite.id, { cms: value });
                toast.success(
                  `CMS updated to WordPress`
                );
              } catch (error) {
                console.error("Failed to update CMS:", error);
                toast.error("Failed to update CMS");
              }
            }}
          >
            <SelectTrigger id="cms-select">
              <SelectValue placeholder="Select CMS">
                WordPress
              </SelectValue>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="wordpress">WordPress</SelectItem>
              
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
};

export default CmsSelectionCard;
